import {sequence} from '@gongxigames/framework/slotV2/fsm/acts/ActFactory';
import {UIState} from '@gongxigames/framework/slotV2/baseClasses/uiState/UIState';
import {DisabledUIAct} from '@gongxigames/framework/slotV2/ui/acts/DisabledUIAct';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {DisabledUIDataWaitAct} from '@gongxigames/framework/slotV2/ui/acts/DisabledUIDataWaitAct';
import {DeactivateIosScrollAct} from '@gongxigames/framework/slotV2/ui/acts/DeactivateIosScrollAct';
import {ActivateIosScrollAct} from '@gongxigames/framework/slotV2/ui/acts/ActivateIosScrollAct';

export class DisabledUIState extends UIState {
    public static readonly ID = 'DisabledUIState';

    public setAct(): void {
        this.act = sequence([
            DeactivateIosScrollAct,
            DisabledUIDataWaitAct,
            DisabledUIAct,
            ActivateIosScrollAct
        ]);
    }

    public canExecute(): boolean {
        return slotStore.isDisabledUIMode.value;
    }
}